import Converter from './Converter';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.virtualGames,
  gameListUrl: 'goldenrace/game_list',
  gameListUrlData: {
    getHeaders: () => ({
      headers: {
        'x-partner-name': projectName,
      },
    }),
  },
  sessionUrlData: {
    url: 'goldenrace/create_session',
    method: QueryTypes.POST,
    converter: converter.convertGameUrl,
    getBody: params => ({
      game_id: params.gameId,
      platform: params.isDesktop ? 'desktop' : 'mobile',
    }),
    getHeaders: () => ({
      headers: {
        'x-partner-name': projectName,
        'x-partner-authorization': parseCookies(),
      },
    }),
  },
  converter,
};
